import { useMemo } from "react";
import { useSelector } from "react-redux";
import { createAuthHttpClient } from "../../../features/auth/authHttp";

export const usePropertyApiClient = () => {
  const user = useSelector((state) => state.auth?.user);
  const directToken =
    user?.accessToken ||
    user?.token ||
    user?.refreshToken ||
    user?.user?.token ||
    user?.user?.refreshToken ||
    "";

  return useMemo(() => {
    const client = createAuthHttpClient({
      timeout: 20000,
    });
    if (directToken) {
      client.interceptors.request.use((config) => {
        if (!config.headers) {
          config.headers = {};
        }
        if (!config.headers.Authorization) {
          config.headers.Authorization = `Bearer ${directToken}`;
        }
        return config;
      });
    }
    return client;
  }, [directToken]);
};
